import {
  AppInput,
  AppButton,
  AppForm,
  AppFormItem,
  AppRow,
  AppCol,
  AppSelect,
  AppModal,
  appMessage,
  appModal,
  useAppForm
} from '@/shared/ui'
import { FunctionComponent, useState } from 'react'

export type fieldsToUpdate = {
  firstName: any
  lastName: any
  photoUrl: string
  clientId: number
}

export type PersonalInfoProps = {
  isVisible: boolean
  userId: number
  firstName: string
  lastName: string
  email: string
  photoUrl: string
  client: string
  clientId: number
  translate: (arg0: string) => string
  onImageChange: (userId: any, fieldsToUpdate: any) => void
  updateUserFunction: (userId: any, fieldsToUpdate: any) => void
  changePasswordClick: () => void
  toClose: () => void
}
export const PersonalInfoModal: FunctionComponent<PersonalInfoProps> = ({
  isVisible = false,
  userId = 0,
  firstName = '',
  lastName = '',
  email = '',
  photoUrl = '',
  client = '',
  clientId,
  translate = (arg0: string) => '',
  onImageChange = () => {},
  updateUserFunction = () => {},
  changePasswordClick = () => {},
  toClose = () => {}
}: PersonalInfoProps): JSX.Element => {
  const gotFields = () => {
    return [
      {
        name: ['firstName'],
        value: firstName
      },
      {
        name: ['lastName'],
        value: lastName
      },
      {
        name: ['email'],
        value: email
      }
    ]
  }
  const { info } = appModal
  const [updateUserForm] = useAppForm()
  const [fields, setFields] = useState(gotFields())
  const [uploadBtn, setUploadBtn] = useState({
    value: null
  })

  const updateUser = () => {
    updateUserForm.validateFields().then(async (values) => {
      const { firstName, lastName, clientId } = values
      const fieldsToUpdate = {
        firstName,
        lastName,
        photoUrl: photoUrl,
        clientId
      }
      if (clientId) {
        fieldsToUpdate.clientId = clientId
      }
      updateUserFunction(userId, fieldsToUpdate)
    })
  }

  const onFinishFailed = (info: any) => {
    console.warn('User profile update validation: ', info)
  }

  return (
    <div id='user-update' className='user-panel-update'>
      <AppModal
        title={translate('user-profile.personal-info')}
        open={isVisible}
        onCancel={toClose}
        centered={true}
        footer={null}
        keyboard={true}
        maskClosable={true}
        width={700}
        closable={true}
      >
        <AppForm
          form={updateUserForm}
          layout='vertical'
          fields={fields}
          onFinish={updateUser}
          onFinishFailed={onFinishFailed}
        >
          <AppRow>
            <AppCol flex={3}>
              <img
                className='user-personal-info-avatar'
                src={photoUrl || 'https://instaleap.s3.amazonaws.com/user-placeholder.png'}
                alt='Logo'
              />
              <br />
              <label id='photo-label' htmlFor='photo' className='user-upload-image-button'>
                {translate('user-profile.upload.photo')}
              </label>
              <input id='photo' type='file' name='file' hidden={true} onChange={(e) => onImageChange(e, userId)} />
            </AppCol>
            <AppCol flex={7}>
              <AppFormItem
                label={translate('user-profile.first-table.name')}
                name='firstName'
                initialValue={firstName}
                rules={[
                  {
                    required: false,
                    message: translate('user-profile.first-table.name')
                  }
                ]}
              >
                <AppInput className='app-input-user' placeholder={translate('user-profile.first-table.note-name')} />
              </AppFormItem>
              <div className='user-form'>
                <AppFormItem
                  label={translate('user-profile.first-table.lastname')}
                  name='lastName'
                  initialValue={lastName || null}
                  rules={[
                    {
                      required: false,
                      message: translate('user-profile.first-table.lastname')
                    }
                  ]}
                >
                  <AppInput
                    className='app-input-user'
                    placeholder={translate('user-profile.first-table.note-lastname')}
                  />
                </AppFormItem>
              </div>
              <div className='user-form'>
                <AppFormItem
                  label={translate('user-profile.first-table.email')}
                  name='email'
                  initialValue={email || null}
                  rules={[
                    {
                      required: false,
                      message: translate('user-profile.first-table.email')
                    }
                  ]}
                >
                  <AppInput autoComplete='new-email' className='app-input-user' disabled />
                </AppFormItem>
              </div>
              <div className='update-pass-buttons'>
                <AppButton key='back' onClick={toClose}>
                  {translate('user-profile.button.cancel')}
                </AppButton>
                <AppFormItem>
                  <AppButton htmlType='submit' variant='primary'>
                    {translate('user-profile.button.save')}
                  </AppButton>
                </AppFormItem>
              </div>
              <div className='update-pass-buttons'>
                <AppButton variant='primary' className='change-password-button' onClick={changePasswordClick}>
                  {translate('user-profile.second-table.title')}
                </AppButton>
              </div>
            </AppCol>
          </AppRow>
        </AppForm>
      </AppModal>
    </div>
  )
}
